import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AnalyticsService, PageTitleService, SeoService } from './core/services';
import { ThemeManager } from './theme/services/theme.service';

@UntilDestroy()
@Component({
  selector: 'ngx-root',
  standalone: true,
  providers: [ConfirmationService],
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  template: `
        <p-toast  />
        <p-confirmDialog></p-confirmDialog>
        <router-outlet></router-outlet>
    `
})
export class AppComponent implements OnInit {
  private readonly _analytics: AnalyticsService = inject(AnalyticsService);
  private readonly _seoService: SeoService = inject(SeoService);
  private readonly _pageTitle: PageTitleService = inject(PageTitleService);
  private readonly _theme: ThemeManager = inject(ThemeManager);
  private readonly _router = inject(Router);

  ngOnInit() {
    this._analytics.trackPageViews();
    this._seoService.trackCanonicalChanges();
    this._pageTitle.trackTitleChanges();
    this._theme.startup();

    this._router.events.pipe(untilDestroyed(this)).subscribe((event: unknown) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    });
  }
}
